
import {
    Sheet,
    SheetContent,
    SheetTrigger,
} from "../components/ui/sheet"
import { useState } from "react"
import { routeService } from "../services/route.service";
import { IconWithTooltip } from "./helpers/IconWithTooltip";
import BtnsList from "./helpers/btns/BtnsList";
import { Button } from "../components/ui/button";
export function MobileNavBar() {
    const [isOpen, setIsOpen] = useState(false);

    function closeMobileNavBar() {
        setIsOpen(false);
    }




    const btnsArr = [
        { domName: "Home", routeName: routeService.HOME },
        { domName: "Careers", routeName: routeService.CAREERS },

    ]

    return (
        <Sheet open={isOpen} onOpenChange={setIsOpen} >
            <SheetTrigger asChild>
                <IconWithTooltip iconName="Menu" tooltipTitle="Menu" />
            </SheetTrigger>
            <SheetContent>
                <div className="flex flex-col items-start gap-4">
                    <BtnsList btnsArr={btnsArr} divClassName="flex flex-col items-center gap-4" closeNavBar={closeMobileNavBar} />

                </div>
            </SheetContent>
        </Sheet>
    )
}
